export default __webpack_public_path__ + "static/media/mail.26605d3d.svg";